var map = {
	"./brands.json": [
		654,
		748
	],
	"./custom-icons.json": [
		655,
		749
	],
	"./full-color.json": [
		656,
		750
	],
	"./light.json": [
		657,
		751
	],
	"./solid.json": [
		658,
		752
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 643;
module.exports = webpackAsyncContext;